export enum UndoToastTypes {
  SHOW = '@undo_toast/SHOW',
  DISMISS = '@undo_toast/DISMISS',
  UNDO_REQUEST = '@undo_toast/UNDO_REQUEST',
  UNDO_SUCCESS = '@undo_toast/UNDO_SUCCESS',
  UNDO_FAILURE = '@undo_toast/UNDO_FAILURE',
}

export type UndoBatchType =
  | 'managed'
  | 'finished'
  | 'tasks'
  | 'progress'
  | 'favorites'
  | 'finish'
  | 'reactivate'
  | 'tasks_status'
  | 'progress_read'
  | 'progress_unread';

export interface UndoToastPayload {
  type: UndoBatchType;
  ids: Array<number>;
  deletedAt?: string;
  undoToken?: string;
  message: string;
  scope?: string | null;
  companyId: number;
  expiresAt: number;
}

export type UndoResultKind = 'restored' | 'partial' | 'nothing' | 'expired' | 'error';

export interface UndoResult {
  kind: UndoResultKind;
  restored: number;
  total: number;
}

export interface LastUndo {
  type: UndoBatchType;
  at: number;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface UndoToastState {
  readonly payload: UndoToastPayload | null;
  readonly request: RequestState;
  readonly result: UndoResult | null;
  readonly lastUndo: LastUndo | null;
}
